/**
 * This file is the entrypoint of browser builds.
 * The code executes when loaded in a browser.
 */
import { verifyPassURI, verifyPassURIOffline, DID_DOCUMENTS, TRUSTED_ISSUERS } from "./main";
export { verifyPassURI, verifyPassURIOffline, DID_DOCUMENTS, TRUSTED_ISSUERS };
